import React, { useContext } from "react";
import { QuoteGroupContext } from "../../providers/RootContextProvider";

// styles
import cx from "classnames";

// components
import ToolTip from "../../../common/components/Tooltips/Tooltip";
import Checkbox from "../../../common/components/Forms/Checkbox/Checkbox";

// types
import ProductType, {
    ClientProductTypes
} from "../../../common/interfaces/enums/ProductType";
import { getProductTypeAsString } from "../../../common/shared/enumHelpers";

interface IProductNavigationButtonV2Props {
    productType: ProductType;
    className?: string;
    setSelectedProducts: React.Dispatch<React.SetStateAction<ProductType[]>>;
    selectedProducts: ProductType[];
    tooltipContent: React.ComponentProps<typeof ToolTip>["tooltipContent"];
}

const ProductNavigationButtonV2: React.FC<IProductNavigationButtonV2Props> = (props) => {
    const {
        productType,
        className,
        selectedProducts,
        setSelectedProducts,
        tooltipContent
    } = props;

    const displayName = getProductTypeAsString(productType, true);

    const isSelectingProduct = selectedProducts.includes(productType);

    const { actions } = useContext(QuoteGroupContext);

    return (
            <div
                className={cx(
                    "panel-basic",
                    "panel-product-selection",
                    "layout-flex-row--justify-spaced",
                    {
                        [productType]: !!productType,
                        [className]: !!className
                    }
                )}>
                <Checkbox
                    name={`Selected-${productType}`}
                    className="space-l"
                    size="l"
                    checked={isSelectingProduct}
                    onChange={(e) => {
                        if (e.target.checked) {
                            setSelectedProducts([...selectedProducts, productType]);
                        } else {
                            const newSelectedProducts = selectedProducts.filter(
                                (product) => product !== productType
                            );
                            actions.setProductEnabled(
                                productType as ClientProductTypes,
                                false
                            );
                            setSelectedProducts(newSelectedProducts);
                        }
                    }}
                    label={
                        <span
                            className={cx(
                                "text-font-size-ml",
                                "text-bold",
                                "text-primary",
                                "space-pre-m"
                            )}>
                            {`${displayName} cover`}
                        </span>
                    }
                />

                <ToolTip className="space-pre-s" tooltipContent={tooltipContent} />
            </div>
    );
};

export default ProductNavigationButtonV2;
